module.exports = {};


//////////////////
// WEBPACK FOOTER
// /opt/vsts/work/1/s/~/core-js/modules/_iterators.js
// module id = ../../../../core-js/modules/_iterators.js
// module chunks = 0